import styled from 'styled-components';
import { Button, Text } from '@grupoboticario/flora-react';
import { CardInfoTitle } from '../sharedStyles';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardInfoTitleSummary = styled(CardInfoTitle)`
  min-height: 50px;
  line-height: 50px;
  position: relative;
  // span {
  //   font-family: ${({ theme }) => theme.fonts.secondary};
  //   font-size: 9px;
  //   font-style: normal;
  //   font-weight: bold;
  //   line-height: 12px;
  //   letter-spacing: 0.08em;
  //   text-transform: uppercase;
  //   color: #000000;
  //   display: inline-block;
  //   width: calc(100% - 200px);
  //   text-align: right;
  //   @media (max-width: 570px) {
  //     width: 100%;
  //   }
  // }
`;

export const ExtraTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin: 26px 8px 24px;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const EditButton = styled(Button)`
  position: absolute;
  top: 22px;
  right: 9px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  line-height: 16px;
`;

export const CardInfoWhatWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 26px;
  @media (max-width: 580px) {
    flex-direction: column;
  }
`;

const CardInfoDescription = styled.div`
  flex: 1;
  border-radius: 4px;
  padding: 22px;
  font-size: 12px;
  line-height: 14px;
  @media (max-width: 580px) {
    width: 100%;
  }
  p {
    margin: 0 0 16px;
  }
`;

export const CardInfoWhatIs = styled(CardInfoDescription)`
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.mainDark};
  font-weight: 400;
  & .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 18px;
  }
`;

export const CardInfoWhatIsnt = styled(CardInfoDescription)`
  background: ${({ theme }) => theme.colors.mainDark};
  color: #fff;
  font-weight: 400;
  & .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 18px;
  }
`;

export const CardInfoFields = styled.div`
  span {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    display: block;
    color: ${({ theme }) => theme.colors.textLight};
    &.singleLine {
      padding: 16px 9px 1px;
    }
  }
  p {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #000000;
    &.singleLine {
      padding: 1px 9px 16px;
    }
  }
  hr {
    border: none;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.line};
  }
`;

const CardInfoDocBase = styled.div`
  background: ${({ theme }) => theme.colors.background};
  padding: 8px 8px 0 14px;
  border-radius: 4px;
  hr {
    width: calc(100% + 28px);
    margin-left: -14px;
    border: none;
    height: 1px;
    background-color: #ffffff;
  }
  span.title {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: ${({ theme }) => theme.colors.main};
    display: block;
    margin: 12px 0 6px;
    span {
      color: ${({ theme }) => theme.colors.error};
    }
  }
  div.files {
    /* justify-content: center;
    display: flex;
    flex-direction: column; */
    margin: 5px 0;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 5px;
      background: ${({ theme }) => theme.colors.textLight};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.text};
      border-radius: 15px;
      height: 2px;
    }
    p {
      font-family: ${({ theme }) => theme.fonts.secondary};
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: 0em;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 3px 0;
      white-space: nowrap;
    }
  }

  @media (max-width: 570px) {
    svg {
      display: inline-block;
      vertical-align: middle;
      margin: 0 10px 0 0;
    }
    span.title {
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 45px);
      margin: 0;
    }
  }
`;

export const CardInfoDocDeclaration = styled(CardInfoDocBase)`
  width: calc(100% - 24px);
  margin: 24px 12px;
  div.files {
    height: 52px;
  }
  div.filesPlaceholder {
    min-height: 12px;
  }
  @media (max-width: 570px) {
    div.info,
    div.files {
      height: auto;
      padding: 12px 0;
    }
  }
`;

export const CardInfoDoc = styled(CardInfoDocBase)`
  width: 100%;
  max-width: 160px;
  div.info {
    min-height: 110px;
  }
  div.files {
    height: 68px;
  }
  @media (max-width: 570px) {
    max-width: 100%;
    div.info,
    div.files {
      height: auto;
      padding: 12px 0;
    }
  }
`;

export const CardInfoDocWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
  margin: 0 12px 12px;
  flex-wrap: wrap;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const CardInfoDocDeclarationRadio = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  margin: 10px 0 15px;
  color: ${({ theme }) => theme.colors.text};
  button[role='radio'] {
    vertical-align: top;
    margin-right: 9px;
  }
`;

export const CardInfoDocDeclarationRadioText = styled(Text)`
  display: inline-block;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.main};
  max-width: calc(100% - 30px);
  width: 100%;
  vertical-align: top;
`;
